import { routeStoreLenses } from 'root/src/client/logic/route/lenses';
const { viewLanguageCode } = routeStoreLenses;
export default viewLanguageCode;
